import { animated, useTransition } from '@react-spring/web';
import { useOvermindActions, useOvermindState } from '#store/overmind';
import { useEffect } from 'react';
import TeaserDetails from '#components/teaser-details/TeaserDetails';

const TeaserDetailsContainer = () => {
  const { queue } = useOvermindState().teaserDetails;
  const { hideDetails } = useOvermindActions().teaserDetails;
  const transitions = useTransition(queue, {
    from: {
      opacity: 0,
      transform: 'scale(0.8) translateX(-50%) translateY(-50%)',
    },
    enter: {
      opacity: 1,
      transform: 'scale(1) translateX(-50%) translateY(-50%)',
      pointerEvents: 'all',
    },
    leave: {
      opacity: 0,
      transform: 'scale(0.8) translateX(-50%) translateY(-50%)',
      pointerEvents: 'none',
    },
    config: { duration: 150 },
  });

  const handleScroll = () => {
    hideDetails();
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      hideDetails();
    };
  }, [hideDetails]);

  return (
    <>
      {transitions((style, item) => (
        <animated.div
          style={{
            ...style,
            position: 'absolute',
            top: item.position.top,
            left: item.position.left,
            transformOrigin: 'left top',
          }}
        >
          <TeaserDetails iri={item.iri} />
        </animated.div>
      ))}
    </>
  );
};

export default TeaserDetailsContainer;
